import controller from './alert-templates.controller';
import template from './alert-templates.html';

const component = {
    controller,
    template,
    bindings: {
        organizationId: '<',
        contactGroups: '<',
        escalationTemplates: '<',
        selectedTemplateName: '<'
    }
};

export default component; 